import { ProductModel } from "./ProductModel";

export class ProductionOrder {
  constructor({ id, number, product, quantity, expectedEndDate, dataInicio, realEndDate, startDate, remarks, codigo_local_estoque, client, produto_padrao, roteiro, numero_lote, local_estoque, op_cod, usuario, concluida = 0 }) {
    this.id = id;
    this.op_cod = op_cod;
    this.number = number;
    this.product = product;
    this.quantity = quantity;
    this.startDate = startDate;
    this.expectedEndDate = expectedEndDate;
    this.dataInicio = dataInicio;
    this.realEndDate = realEndDate;
    this.remarks = remarks;
    this.codigo_local_estoque = codigo_local_estoque;
    this.client = client; // novo campo
    this.usuario = usuario;
    this.produto_padrao = produto_padrao;
    this.roteiro = roteiro;
    this.numero_lote = numero_lote;
    this.local_estoque = local_estoque;

    this.concluida = Number(concluida) || 0;
  }

  static _asFlag(v) {
    return v ? 1 : 0;
  }

  static fromJson(json) {
    return new ProductionOrder({
      id: json.id,
      op_cod: json.op_cod,
      number: json.opNum,
      product: ProductModel.fromJson(json.produto),
      quantity: json.qt,
      realEndDate: json.dataFimReal ? new Date(json.dataFimReal) : null,
      startDate: json.dataInicio ? new Date(json.dataInicio) : null,
      expectedEndDate: new Date(json.dataPrevista),
      dataInicio: new Date(json.dataInicio),
      remarks: json.obs,
      codigo_local_estoque: json.codigo_local_estoque,
      produto_padrao: json.produto_padrao,
      roteiro: json.roteiro,
      numero_lote: json.numero_lote,
      local_estoque: json.local_estoque
        ? {
            id: json.local_estoque.id,
            codigo_local_estoque: json.local_estoque.codigo_local_estoque,
            codigo: json.local_estoque.codigo,
            descricao: json.local_estoque.descricao,
          }
        : null,
      client: json.cliente
        ? {
            id: json.cliente.id,
            name: json.cliente.nome,
          }
        : null,
      usuario: json.usuario
        ? {
            id: json.usuario.id,
            name: json.usuario.name,
          }
        : null,

      concluida: json.concluida ?? 0,
    });
  }

  get isConcluida() {
    return this.concluida === 1;
  }

  getIsEditavel(funcionalidadesDoUsuario = []) {
    // Editável se não concluída OU se tiver a permissão 136
    return !this.isConcluida || funcionalidadesDoUsuario.includes(136);
  }

  toJson() {
    const children = Array.isArray(this.product?.children) ? this.product.children : [];
    const firstLevelActive = children.filter((it) => it && it._status !== "removed");
    const itemsToSeparate = firstLevelActive.map((e) => ({
      produto_cod: e.id,
      qt: e.quantity,
    }));

    return {
      op_cod: this.op_cod,
      produto_cod: this.product.id,
      dt_producao_inicio: this.startDate ? this.startDate.toISOString().split("T")[0] : null,
      dt_previsao: this.expectedEndDate ? this.expectedEndDate.toISOString().split("T")[0] : null,
      dt_producao_fim: this.realEndDate ? this.realEndDate.toISOString().split("T")[0] : null,
      qt_produzir: this.quantity,
      observacoes: this.remarks,
      codigo_local_estoque: this.codigo_local_estoque,
      produto_padrao: this.produto_padrao,
      roteiro: this.roteiro,
      itens: itemsToSeparate,
    };
  }
}
